import React from 'react'
import { connect } from 'react-redux'
import { ApiProvider, System } from '@leverege/api-redux'
import { RulesScreen } from '@leverege/ui-rule'
import { BreadcrumbActions } from '~/actions'
import SetupBlueprints from '../rule/SetupBlueprints'
import Loading from '../../views/Loading'

class SystemRulesScreen extends React.Component {

  static contextType = ApiProvider.Context

  constructor( props ) {
    super( props )
    this.state = {
      loading : true
    }
  }

  componentDidMount() {
    // We need Blueprints and Relationships to be loaded
    const api = this.context
    const { projectId, dispatch } = this.props
    dispatch( BreadcrumbActions.setBreadcrumbs( [ ] ) )

    this.setState( { loading : true, error : null } )
    SetupBlueprints.run( api, projectId, {} )
      .then( 
        ( ) => { this.setState( { loading : false, error : null } ) },
        ( error ) => { console.error( error ); this.setState( { loading : false, error } ) }
      )
  }

  onVisit = ( evt ) => {
    const { history, location } = this.props
    history.push( `${location.pathname}/${evt.id}` )

  }

  render() {
    const { systemId } = this.props
    const { loading, error } = this.state
    if ( error ) {
      return (
        <div>Error loading blueprints: {error.message}</div>
      )
    }
    if ( loading ) {
      return (
        <Loading show message="Loading Blueprints"/>
      )
    }
    const actions = System( systemId )
    
    return (
      <RulesScreen 
        delegate={actions} 
        resourceType="system" 
        resourceId={systemId} 
        onVisitRule={this.onVisit} />
    )
  }
}

export default connect(
  ( state, props ) => {
    const systemId = props?.match?.params?.systemId
    const projectId = props?.match?.params?.projectId
    return {
      systemId,
      projectId
    }
  }
)( SystemRulesScreen );
